// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1yNu1","requiredAsterisk":"Info_requiredAsterisk__2SI6D"};